import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import postulacionesParaAdminsServices from '../../services/postulacionesParaAdminsServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import { Button, Modal, Form } from 'react-bootstrap';
import {useReactToPrint} from 'react-to-print';
import TextAreaControl from '../../container/customizedInputs/TextAreaControl';
import TextControl from '../../container/customizedInputs/TextControl';
import { errorClassification } from '../../errorHandler';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';

// REPORTES
import Postulantes from '../../container/reportes/Postulantes';

const ListaPostulaciones = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const postulanteToPrintRef = useRef();
  const handlePrintPostulante = useReactToPrint({
    content: () => postulanteToPrintRef.current,
  })

  const [postulaciones, setPostulaciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [adjuntos, setAdjuntos] = useState([]);
  const [postulacionSeleccionada, setPostulacionSeleccionada] = useState({});
  const [renderPostulante, setRenderPostulante] = useState(false);
  const [renderHTML, setRenderHTML] = useState(false);
  const [columnas, setColumnas] = useState([
    {nombre: "Concurso", nombreCampo: "ofertas.titulo", ordenar: true},
    {nombre: "Nombre", nombreCampo: "usuarios.nombre", ordenar: true, className: "text-end"},
    {nombre: "Apellido", nombreCampo: "usuarios.apellido", ordenar: true, className: "text-end"},
    {nombre: "Email", nombreCampo: "usuarios.email", ordenar: true, className: "text-end"},
    {nombre: "Estado", nombreCampo: "ofertas_usuarios.estado", ordenar: true, className: "text-end"},
    {nombre: "Puntaje", nombreCampo: "ofertas_usuarios.puntaje", ordenar: true, className: "text-end"},
    {nombre: "Fecha de Postulación", nombreCampo: "ofertas_usuarios.created_at", ordenar: true, className: "text-end"},
    {nombre: "Acciones", ordenar: false, className: "text-end"},
    ]);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  // modal messages B
  const [showModalB, setShowModalB] = useState(false);

  const handleShowModalB = (indice) => {
    setPostulacionSeleccionada(postulaciones[indice])
    setShowModalB(true)
  };
  const handleCloseModalB = () => { setShowModalB(false); };

  useEffect(() => {
    obtenerPostulaciones();
    obtenerEstados();
  }, []);

  useEffect(() => {
    setRenderPostulante(Object.keys(postulacionSeleccionada).length > 0)
  }, [postulacionSeleccionada]);



  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor' || authInformation.rol === 'Jurado')){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Registrado')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  useEffect(() => {
    if(sortedColumn!==null){
      obtenerPostulaciones(columnas[sortedColumn].nombreCampo + " " + sortOrder)
    }
  }, [sortedColumn, sortOrder]);


  const obtenerPostulaciones = async (sortBy='') => {
    try {
      const data = await postulacionesParaAdminsServices.obtenerPostulaciones(sortBy);

      setPostulaciones(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const obtenerEstados = async () => {
    try {
      const data = await postulacionesParaAdminsServices.obtenerEstados();

      setEstados(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarPostulacion = async (postulacion) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar la postulación de ${postulacion.usuario.nombre}?`)){

        await postulacionesParaAdminsServices.eliminarPostulacion(postulacion.id);

        setPostulaciones([...postulaciones].filter((psts) => psts.id !== postulacion.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const listarPostulaciones = postulaciones && postulaciones.map((postulacion, index) => {
    return (
      <tr className='text-end' key={index}>
        <td className='text-start'>
          {postulacion.oferta.titulo}
        </td>
        <td>
          {postulacion.usuario.nombre}
        </td>
        <td>{postulacion.usuario.apellido}</td>
        <td>{postulacion.usuario.email}</td>
        <td>{postulacion.estado}</td>
        <td>{postulacion.puntaje}</td>
        <td>{postulacion.fecha_postulacion}<br />({postulacion.dias_desde_fecha_postulacion} días atrás)</td>
        <td>
          <button className="btn btn-primary me-2" type="button" onClick={() => handleShowModalB(index)}>Ver</button>
          {/* {
          // una vez el jurado cambio el estado a admisible, el admin no puede cambiar el estado
          authInformation.rol === 'Admin' && (
            <button disabled={postulacion.estado==3} className="btn btn-danger" onClick={()=>eliminarPostulacion(postulacion)} >Eliminar</button>
          )} */}
        </td>
      </tr>
    )
  })

  const orderBy = (e, indice) => {
    e.preventDefault()

    if (sortedColumn === indice) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(indice);
      setSortOrder("asc");
    }
  }

  const columnasTabla = () => {
      return (
        <tr>
          {
            columnas.map((col, index) => (
              <th className={col.className} scope="col" key={index}>
                {
                  (col.ordenar === true) ? (
                    <a className='icon-link' onClick={(e) => orderBy(e, index)} href="#">{col.nombre}</a>
                  ) : (
                    <>{col.nombre}</>
                  )
                }
                {
                  sortedColumn === index && (

                  sortOrder === 'desc' ? (
                    <BsFillCaretDownFill />
                    ) : (
                    <BsFillCaretUpFill />
                    )
                  )
                }
              </th>
            ))
          }
        </tr>
      )
  }

  const handleInput = (e) => {
    e.persist();
    const { name, value } = e.target;

    setPostulacionSeleccionada({...postulacionSeleccionada,
        [name]: value
    })
  }

  const handleInputAdjuntos = (e) => {
    const { name, files } = e.target;

    setAdjuntos(Object.keys(files).map(v => files[v]))

    e.target.value = '';
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    actualizarPostulacion()
  }

  const eliminarAdjuntoPuntaje = async (id, adjunto_id) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar el adjunto?`)){
        const data = await postulacionesParaAdminsServices.eliminarAdjuntoPuntaje(id, adjunto_id);
        setPostulacionSeleccionada(data)
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };


  const actualizarPostulacion = async () => {
    try {
      if(window.confirm(`Está seguro que quiere actualizar la información?`)){

        const formData =  new FormData();
        formData.append('postulacion[estado]', postulacionSeleccionada.estado)
        formData.append('postulacion[comentarios]', postulacionSeleccionada.comentarios || '')
        formData.append('postulacion[antecedentes]', postulacionSeleccionada.antecedentes)
        formData.append('postulacion[examen_escrito]', postulacionSeleccionada.examen_escrito)
        formData.append('postulacion[examen_oral]', postulacionSeleccionada.examen_oral)
        formData.append('postulacion[coloquio]', postulacionSeleccionada.coloquio)
        adjuntos.forEach((adjunto, index) => (
          formData.append('postulacion[adjuntos_puntaje][]', adjunto)
        ))

        const data = await postulacionesParaAdminsServices.actualizarPostulacion(postulacionSeleccionada.id, formData, true);
        setPostulacionSeleccionada(data)
        handleShowModal("Datos actualizados")
        obtenerPostulaciones();
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  }

  const generarReportePostulaciones = async () => {
    const blob = await pdf( <Postulantes postulaciones={postulaciones} estados={estados} /> ).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank'); // Abre el PDF en una nueva pestaña
  };
  
  return (
    <>
      <div >
      <h1>Lista de postulaciones</h1>
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">

            <table className="table table-striped table-sm">
              <thead>
              {columnasTabla()}
              </thead>
              <tbody>
                {listarPostulaciones}
              </tbody>
            </table>
          </div>
          <div className='text-end'>
            <button className="btn btn-dark btn-lg px-4" type="button" onClick={() => generarReportePostulaciones()} >Imprimir</button>
          </div>
          </>
        )
      }
      </div>
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />

      <Modal size="xl" backdrop="static" keyboard={false} show={showModalB} onHide={() => handleCloseModalB()} >
        <Modal.Header closeButton>
          <Modal.Title>{renderPostulante && (`${postulacionSeleccionada.usuario.nombre} ${postulacionSeleccionada.usuario.apellido}`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <pre>{JSON.stringify(adjuntos, null, 2)}</pre> */}
          {
            renderPostulante && (
              <div ref={postulanteToPrintRef}>
                <h1>{postulacionSeleccionada.oferta.titulo}</h1>
                <h5>Fecha de postulación: {postulacionSeleccionada.fecha_postulacion} <span className='badge bg-secondary'> {postulacionSeleccionada.dias_desde_fecha_postulacion} días</span></h5>
                <h5>Última actualización: {postulacionSeleccionada.fecha_actualizacion}</h5>

                <hr />
                <div className='row mb-3'>
                  <div className='col-sm-6'>
                    <b>Nombre:</b> {postulacionSeleccionada.usuario.nombre}
                  </div>
                  <div className='col-sm-6'>
                    <b>Apellido:</b> {postulacionSeleccionada.usuario.apellido}
                  </div>
                  <div className='col-sm-6'>
                    <b>Documento:</b> {postulacionSeleccionada.usuario.documento_identidad}
                  </div>
                  <div className='col-sm-6'>
                    <b>Email:</b> {postulacionSeleccionada.usuario.email}
                  </div>
                </div>
                <hr />
                <b>Estado de condiciones:</b> {postulacionSeleccionada.estado_condiciones}
                <hr />
                <div>
                  {
                    postulacionSeleccionada.adjuntos_postulaciones.length > 0 && (
                      <h5>Archivos adjuntos</h5>
                    )
                  }
                  {
                    postulacionSeleccionada.adjuntos_postulaciones.map((adjunto, index) => (
                      <a key={index} href={adjunto.archivoUrl} target="_blank" className="btn btn-info me-3" role="button" aria-disabled="true">{adjunto.documentacion.nombre}</a>
                    ))
                  }
                </div>
                {
                  (authInformation.rol === 'Admin' || authInformation.rol === 'Jurado') && (
                    <Form onSubmit={handleFormSubmit}>
                      <div className='mb-3'>
                        <Form.Group>
                          {
                            // una vez el jurado cambio el estado a admisible, el admin no puede cambiar el estado
                            estados && estados.map((estado, idx) => (
                              <Form.Check
                                key={idx}
                                inline
                                value={idx}
                                label={estado}
                                name="estado"
                                type="radio"
                                disabled={authInformation.rol === 'Jurado'}
                                id={"grupo"+(idx+1)}
                                onChange={handleInput}
                                checked={postulacionSeleccionada.estado == idx}
                              />
                            ))
                          }
                        </Form.Group>
                      </div>
                      <div className='alert alert-primary mb-3' role='alert'>
                          Puede enviar cualquier notificación al postulante enviando un email a <b>{postulacionSeleccionada.usuario.email}</b>. También puede clickear <a href={`mailto:${postulacionSeleccionada.usuario.email}`} target="_blank">aquí</a> para enviar el email.
                      </div>
                      <div className='mb-3'>
                        <TextAreaControl
                            value={postulacionSeleccionada.comentarios}
                            name={'comentarios'}
                            disabled={authInformation.rol === 'Jurado'}
                            handleInput={handleInput}
                          />
                      </div>
                      {
                        (authInformation.rol === 'Jurado' || authInformation.rol === 'Admin') ? (
                          <>
                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.antecedentes}
                                      name={'antecedentes'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.examen_escrito}
                                      name={'examen_escrito'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.examen_oral}
                                      name={'examen_oral'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.coloquio}
                                      name={'coloquio'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                              </div>


                            </div>
                            <div className='mb-3'>
                              <b>Puntaje Total: </b> {postulacionSeleccionada.puntaje}
                              {/* <TextControl
                                  value={postulacionSeleccionada.puntaje}
                                  name={'puntaje'}
                                  handleInput={handleInput}
                                  disabled={postulacionSeleccionada.estado !== "admisible"}
                                  type={'number'}
                                /> */}
                            </div>
                            <div className='mb-3'>
                              <input
                                placeholder="Adjunte los archivos"
                                className="form-control"
                                onChange={(e) => handleInputAdjuntos(e)}
                                name="adjuntos_puntaje"
                                type="file"
                                multiple={true}
                                id={`adjuntos_puntaje`}
                              />
                            </div>
                            <div className='mb-3'>
                              {
                                postulacionSeleccionada.archivos_adjuntos_puntaje.map(adjunto => (
                                  <div key={adjunto.id}>
                                    <div className="btn-group" role="group">
                                    <a href={adjunto.url} target="_blank" className="btn btn-primary" role="button" aria-disabled="true">Descargar {adjunto.nombre}</a>
                                    <button className='btn btn-danger' onClick={() => eliminarAdjuntoPuntaje(postulacionSeleccionada.id, adjunto.id)} type='button'>Eliminar</button>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>


                          </>
                        ) : (
                          postulacionSeleccionada.puntaje > 0 && (
                            <h6>Puntaje: {postulacionSeleccionada.puntaje}</h6>
                          )
                        )
                      }
                      {
                        postulacionSeleccionada.puntaje > 0 && postulacionSeleccionada.usuario_puntaje && (
                          <>
                          <h6>Usuario Puntuador: {`${postulacionSeleccionada.usuario_puntaje.nombre} ${postulacionSeleccionada.usuario_puntaje.apellido}`}</h6>
                          <h6>Fecha Puntuación: {`${postulacionSeleccionada.fecha_puntaje}`}</h6>
                          </>
                        )
                      }
                      <button className='btn btn-primary' type="submit" >Guardar</button>
                    </Form>
                  )
                }



              </div>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={() => handlePrintPostulante()}>
            Imprimir
          </Button>
          <Button variant="secondary" onClick={() => handleCloseModalB(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      </>

  );
};

export default ListaPostulaciones;